const SvgExact = (props) => (
  <svg height="1em" viewBox="0 0 17 18" width="1em" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M-1 0h18v18H-1z" />
      <g fill="currentColor">
        <path
          d="M16.15 2.55h-1.912V.638a.638.638 0 0 0-1.275 0v1.275a.638.638 0 0 0-1.275 0v2.286l-.7.7a5.074 5.074 0 0 0-3.125-1.073 5.105 5.105 0 0 0-5.1 5.1c0 2.813 2.287 5.1 5.1 5.1 2.812 0 5.1-2.287 5.1-5.1 0-1.177-.4-2.262-1.073-3.125l.7-.7h2.286a.638.638 0 0 0 0-1.275h1.275a.638.638 0 0 0 0-1.275l-.001-.001zm-4.462 6.375a3.83 3.83 0 0 1-3.826 3.825 3.83 3.83 0 0 1-3.825-3.825A3.83 3.83 0 0 1 7.862 5.1c.825 0 1.59.263 2.215.709L8.193 7.693a1.275 1.275 0 1 0 .901.901L10.98 6.71c.446.626.709 1.39.709 2.215z"
          fillRule="nonzero"
        />
        <path d="M15.593 8.925c0-.715-.098-1.425-.29-2.108a.716.716 0 1 0-1.38.39 6.303 6.303 0 0 1-6.059 8.013 6.303 6.303 0 0 1-6.296-6.295A6.303 6.303 0 0 1 9.58 2.866a.716.716 0 1 0 .39-1.38 7.771 7.771 0 0 0-2.107-.29c-4.263 0-7.73 3.468-7.73 7.73 0 2.226.945 4.235 2.456 5.646L.4 16.762a.638.638 0 0 0 .903.902l2.296-2.296a7.692 7.692 0 0 0 4.266 1.287 7.681 7.681 0 0 0 4.266-1.287l2.296 2.296a.64.64 0 0 0 .903 0 .638.638 0 0 0 0-.902l-2.19-2.19a7.709 7.709 0 0 0 2.457-5.646l-.004-.001z" />
      </g>
    </g>
  </svg>
)

export default SvgExact
